export default "__VITE_ASSET__e7aCvqCG__"